import * as React from 'react'

export const SVG_Tick = (props: { color?: string; height?: string; width?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '27'}
        height={props.height || '27'}
        viewBox="0 0 27 27"
    >
        <path
            fill={props.color || 'var(--green)'}
            fillRule="evenodd"
            d="M12.06 19.468L7.452 15.23c-.461-.424-.461-1.059 0-1.483a1.182 1.182 0 0 1 1.612 0l3.572 3.284 6.105-9.427c.346-.53 1.037-.635 1.613-.318.576.318.691.954.346 1.483l-6.912 10.592c-.224.295-.341.53-.862.53-.345 0-.636-.212-.866-.424z"
        />
    </svg>
)
